class AdMinimap {

    constructor() {
        const REDUCTION = 0.11;

        return {
            restrict: 'E',
            scope: {
                'workspaceOffset': '=',
                'adunit': '='
            },
            templateUrl: 'builder/minimap.html',
            link: ($scope, $el) => {

                let $viewport = angular.element('ad-builder');

                $scope.viewportStyles = {
                    width: ($viewport.width() - 96) * REDUCTION,
                    height: ($viewport.height() - 24) * REDUCTION,
                    top: -($scope.workspaceOffset.top * REDUCTION),
                    left: -($scope.workspaceOffset.left * REDUCTION),
                    cursor: 'move'
                };
                
                var $workspace = $('.workspace');
                angular.element('.minimap-viewport').draggable({
                    appendTo: 'ad-minimap',
                    containment: 'ad-minimap',
                    drag: (ev, ui) => {
                        $workspace.css({
                            top: -(ui.position.top / REDUCTION),
                            left: -(ui.position.left / REDUCTION)
                        });
                        $scope.workspaceOffset = { 
                            top: -(ui.position.top / REDUCTION), 
                            left: -(ui.position.left / REDUCTION)
                        };
                        $scope.$apply();
                    }
                });

                $scope.reduce = (value) => Math.floor(value * REDUCTION);

                $scope.$watch('workspaceOffset', () => {
                    $scope.viewportStyles.top = -($scope.workspaceOffset.top * REDUCTION);
                    $scope.viewportStyles.left = -($scope.workspaceOffset.left * REDUCTION);
                }, true);
            }
        };
    }

}

angular.module('cpm')
    .directive('adMinimap', [() => {
        'use strict';
        return new AdMinimap();
    }]);
